import { useState } from 'react';

const seleccionables = filas => filas.filter(fila => fila._id && fila.estadoAlumno === true).map(fila => fila._id);

const useSeleccionArchivado = (helper, onDone) => {
    const [seleccionados, setSeleccionados] = useState(new Set());

    const toggle = id => {
        setSeleccionados(prev => {
            const nuevo = new Set(prev);
            nuevo.has(id) ? nuevo.delete(id) : nuevo.add(id);
            return nuevo;
        });
    };

    const bloqueCompleto = filas => {
        const ids = seleccionables(filas);
        return ids.length > 0 && ids.every(id => seleccionados.has(id));
    };

    const bloqueVacio = filas => seleccionables(filas).length === 0;

    const toggleBloque = filas => {
        const ids = seleccionables(filas);
        const completo = bloqueCompleto(filas);
        setSeleccionados(prev => {
            const nuevo = new Set(prev);
            ids.forEach(id => completo ? nuevo.delete(id) : nuevo.add(id));
            return nuevo;
        });
    };

    // Al filtrar un bloque, se quitan los ids que dejan de verse para no archivar algo oculto
    const podar = (todas, visibles) => {
        const idsVisibles = new Set(visibles.map(fila => fila._id));
        setSeleccionados(prev => {
            const nuevo = new Set(prev);
            todas.forEach(fila => { if (!idsVisibles.has(fila._id)) nuevo.delete(fila._id); });
            return nuevo;
        });
    };

    const limpiar = () => setSeleccionados(new Set());

    const archivar = async () => {
        const res = await helper.archivarVarios([...seleccionados]);
        if (res?.success) {
            limpiar();
            onDone();
        }
    };

    return {
        total: seleccionados.size,
        estaSeleccionado: id => seleccionados.has(id),
        toggle,
        bloqueCompleto,
        bloqueVacio,
        toggleBloque,
        podar,
        limpiar,
        archivar
    };
};

export default useSeleccionArchivado;
